import moment from "moment";

export const EXPIRING_DAYS = 30;

// expired comes from the server (is_expired); null end_date means the branch follows the store
export const branchStatus = (branch, today = moment()) => {
  if (!branch) return "follows_store";
  if (branch.is_expired) return "expired";
  if (!branch.end_date) return "follows_store";
  const days = moment(branch.end_date, "YYYY-MM-DD").diff(
    moment(today).startOf("day"),
    "days",
  );
  return days <= EXPIRING_DAYS ? "expiring" : "active";
};

export const branchEndDateLabel = (branch, t) => {
  if (!branch || !branch.end_date) return t("same_as_store");
  return moment(branch.end_date, "YYYY-MM-DD").format("DD-MM-YYYY");
};
